<template>
    <div>
        <div class="navigation-packet detail-info-button" v-if="!activityOpened">
            <button class="btn btn-yellow btn-packet radius-4" @click="activityOpened = true">{{ $helper.trans('Show_summary') }}</button>
        </div>
        <div class="toggle-wrap tracking-summary custom-tracking-summary-wrap d-block" v-if="activityOpened">
            <div class="toggle-content p-0">
                <div class="toggle-packet-content">
                    <div class="toggle-column-big">
                        <w-s-activity-history-component
                            :parcel="parcel"
                        ></w-s-activity-history-component>
                        <button class="btn btn-yellow close-btn" @click="activityOpened = false">{{ $helper.trans('Close') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            activityOpened: false,
        }
    },
    props: {
        parcel: {
            type: Object,
            require: true,
        },
        otherParcels: {
            type: Boolean,
            require: false,
            default: false,
        },
    },
}
</script>
